import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useSoyuzExperiment } from '@spotahome/soyuz/client';

import ShareModalWrapper from '../ShareModalWrapper';

import FavoriteButton from '../BookNowCard/FavoriteButton';
// eslint-disable-next-line import/no-named-as-default

import './ListingSocialButtons.scss';

let SOCIAL_COMPONENTS = [];

const ListingSocialButtons = ({ listingId, deviceOS }) => {
  SOCIAL_COMPONENTS = [
    {
      locoKey: 'listing.social-buttons.share',
      SocialComponent: ShareModalWrapper,
      extraProps: {
        listingId,
        className: 'listing-social__share-statistics',

        deviceOS
      }
    },
    {
      locoKey: 'listing.social-buttons.favorite',
      SocialComponent: FavoriteButton,
      extraProps: {
        iconWithBorder: true
      }
    }
  ];

  const className = classnames('listing-social');

  return (
    <div className={className}>
      {SOCIAL_COMPONENTS.map(({ locoKey, SocialComponent, extraProps }) => (
        <SocialComponent key={locoKey} {...extraProps} />
      ))}
    </div>
  );
};

ListingSocialButtons.propTypes = {
  listingId: PropTypes.string.isRequired,
  deviceOS: PropTypes.string.isRequired
};

export default ListingSocialButtons;
